import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { getAnonFavs, clearAnonFavs } from "../lib/storage";
import { toast } from "sonner";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/discover");
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id });
        signIn(r.data.session_token, r.data.user);
        const anon = getAnonFavs();
        if (anon.length) {
          try { await api.post("/favorites/sync", { location_ids: anon }); } catch {}
          clearAnonFavs();
        }
        toast.success(`Welcome${r.data.user.name ? ", " + r.data.user.name.split(" ")[0] : ""}!`);
        navigate("/discover", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed — please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [hash, navigate, signIn]);

  return (
    <div className="min-h-screen flex items-center justify-center text-brand-subtle" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
